function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoticeUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.25.25H1.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h4.5L10 20.5l3.75-3.75h4.5a1.5 1.5 0 001.5-1.5V1.75a1.5 1.5 0 00-1.5-1.5zM10 13.75a1.403 1.403 0 01-1.02-.412 1.41 1.41 0 010-2.025 1.424 1.424 0 011.02-.405c.383-.007.752.139 1.027.405a1.41 1.41 0 010 2.024A1.416 1.416 0 0110 13.75zm-.938-3.967L8.905 3.25h2.25l-.18 6.533H9.063z",
    fill: props.color
  }));
}

export default SvgIconNoticeUser;